<template>
    <div class="">
         <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">Reports</li>
                </ol>
                <label class="form-label"> <h4>Reports</h4></label>
            </div>
            <div class="d-flex">
                 <button  class="btn d-flex align-item-center btn-success" @click="downloadExcel"><i class="ri-download-line me-1"></i>Download Report</button>
            </div>
        </div>
        <div class="card br-16 card-shadow">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <div><label class="form-label">District</label></div>
                            <a type="button" class="text-danger me-2" @click="reset('district')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->


                        <!-- <Search
                            :class="{ 'is-invalid': errors?.district_id }"
                            :customClass="{ 'is-invalid': errors?.district_id }"
                            :initialize="meta.district_id"
                            id="district_id"
                            label="district"
                            placeholder="Select District"
                            :data=" districts"
                            @input=" district => meta.district_id = district"
                            @selectsearch="getSchools(meta.district_id)"
                        >
                        </Search> -->

                         <Search
                            :class="{ 'is-invalid': errors?.district_id }"
                            :customClass="{ 'is-invalid': errors?.district_id }"
                            :initialize="meta.district_id"
                            id="district_id"
                            label="district"
                            placeholder="Select District"
                            :data=" districts"
                            @input=" district => meta.district_id = district"
                            @selectsearch="updateDistrictID(meta.district_id)"
                        >
                        </Search>


                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <div><label class="form-label">School</label></div>
                            <a type="button" class="text-danger me-2" @click="reset('school')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                         <SchoolSearch
                            @selectSearch="checkInitalDistrict($event)"
                            :district_ids="district_ids"
                            :initialize="meta.school_name"
                            @selectSchool="selectSchool($event)"
                            ref="school_id"
                            :class="{ 'is-invalid': errors.district_error }"
                        >
                        </SchoolSearch>
                        <span v-if="errors.district_error" class="invalid-feedback">{{ errors.district_error }}</span>
                         <!-- <Search
                            :class="{ 'is-invalid': errors?.school_id }"
                            :customClass="{ 'is-invalid': errors?.school_id }"
                            :initialize="meta.school_id"
                            id="school_id"
                            label="school_name"
                            placeholder="Select School"
                            :data=" schools"
                            @input=" school => meta.school_id = school"
                        >
                        </Search> -->
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <label class="form-label">Users</label>
                            <a type="button" class="text-danger me-2" @click="reset('users')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                        <Search
                            :class="{ 'is-invalid': errors?.user_id }"
                            :customClass="{ 'is-invalid': errors?.user_id }"
                            :initialize="meta.user_id"
                            id="user_id"
                            label="name"
                            placeholder="Select User"
                            :data=" users"
                            @input=" user => meta.user_id = user"
                        >
                        </Search>
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <label class="form-label">Board</label>
                            <a type="button" class="text-danger me-2" @click="reset('board')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                        <select class="form-control" v-model="meta.board">
                            <option value="">Select Board</option>
                            <option value="CBSC">CBSC</option>
                            <option value="ICSC">ICSC</option>
                            <option value="State">State</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <label class="form-label">Stages</label>
                            <a type="button" class="text-danger me-2" @click="reset('stages')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                        <select class="form-control" :class="{ 'is-invalid': errors.stage }" v-model="meta.stage_id" >
                            <option value="">Select Stages</option>
                            <option v-for="stage, key in stages" :key="key" :value="stage.stage_id">{{stage.stage}}</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <label class="form-label">KG Strength</label>
                        <VueSlider
                            v-model="value"
                            :min="0"
                            :max="1000"
                            :interval="10"
                            contained
                        />
                        <span v-if="errors.kg_strength" class="invalid-feedback">{{ errors.kg_strength[0] }}</span>
                    </div>
                    <div class="col-md-3 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <label class="form-label">From To Date</label>
                            <a type="button" class="text-danger me-2" @click="reset('from_to_date')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                        <flatPickr class="form-control" placeholder="Select Date Range" ref="flatpickr"
                            :class="{ 'is-invalid': errors?.date_time }" v-model="meta.date_time"
                            :config="config" @onChange="getSelectedDates" >
                        </flatPickr>
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <label class="form-label">From Date</label> -->
                        <input class="form-control" type="number" :class="{ 'is-invalid': errors.pincode }" placeholder="Pincode" v-model="meta.pincode">
                        <span v-if="errors.pincode" class="invalid-feedback">{{ errors.pincode[0] }}</span>
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <label class="form-label">Place</label> -->
                        <input class="form-control" type="text" :class="{ 'is-invalid': errors.place }" placeholder="Place" v-model="meta.place">
                        <span v-if="errors.place" class="invalid-feedback">{{ errors.place[0] }}</span>
                    </div>
                    <div class="col-md-2 mb-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="isLatest" v-model="meta.is_latest">
                            <label class="form-check-label" for="isLatest">
                                Latest Entries
                            </label>
                        </div>
                    </div>
                    <div class="col-md-2 mb-3">
                        <button type="button" @click="search" class="btn btn-primary me-2">Search</button>
                        <button type="button" @click="reset()" class="btn btn-danger"><i class="ri-close-line lh-1"></i></button>
                    </div>
                </div>
                <div class="table-responsive table-responsive-sm" style="height: 330px; overflow: scroll;" >
                    <table class="table table-sm text-nowrap table-bordered mb-0">
                        <thead>
                            <tr v-if="filteredSessionForms.length == 0">
                                <th class="text-center">Sl.No</th>
                                <th>User</th>
                                <th>School Name</th>
                                <th>KG Strength</th>
                                <th>Place</th>
                                <th>Address</th>
                                <th>Visited Date</th>
                                <th>Present Stage</th>
                                <th>Next Stage</th>
                                <th>Next Reminder Date & Time</th>
                                <th>Status</th>
                                <th>Remark</th>
                                <th class="text-center">Actions</th>
                            </tr>
                            <tr v-else>
                                <th class="text-center sticky-col col-0 sticky">Sl.No</th>
                                <!-- <th @click="sort('user_name')" class="sticky-col col-1 sticky">
                                    User
                                    <span>
                                        <i v-if="meta.keyword == 'user_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'user_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('school_name')" class="sticky-col col-2 sticky">
                                    School Name
                                    <span>
                                        <i v-if="meta.keyword == 'school_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'school_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th class="sticky-col col-3 sticky">
                                    KG Strength
                                </th>
                                <th @click="sort('place')">
                                    Place
                                    <span>
                                        <i v-if="meta.keyword == 'place' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'place' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('address')">
                                    Address
                                    <span>
                                        <i v-if="meta.keyword == 'address' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'address' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('date_time')">
                                    Visited Date
                                    <span>
                                        <i v-if="meta.keyword == 'date_time' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'date_time' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th> -->
                                <th class="sticky-col col-1 sticky">User</th>
                                <th class="sticky-col col-2 sticky">School Name</th>
                                <th class="sticky-col col-3 sticky">KG Strength</th>
                                <th>Place</th>
                                <th>Address</th>
                                <th>Visited Date</th>
                                <th>Present Stage</th>
                                <th>Next Stage</th>
                                <th>Next Reminder Date & Time</th>
                                <th>Status</th>
                                <th>Remark</th>
                                <th class="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="filteredSessionForms.length == 0">
                                <td colspan="13" class="text-center">No records found</td>
                            </tr>
                            <tr v-for="(session_form, key) in filteredSessionForms" :key="key">
                                <td class="text-center sticky-col col-0 sticky">{{ meta.from + key }}</td>
                                <td class="sticky-col col-1 sticky">{{session_form?.User?.name}}</td>
                                <td class="sticky-col col-2 sticky text-wrap">{{ session_form?.School?.school_name}}</td>
                                <td class="sticky-col col-3 sticky">
                                    <span v-for="fields, key in session_form?.School?.SessionFields" :key="key">
                                        <span v-if="fields?.field_name == 'KG Strength'">{{ fields?.value }} </span>
                                    </span>
                                </td>
                                <td>{{ session_form?.School?.place }}</td>
                                <td>{{ session_form?.School?.address }}</td>
                                <td>{{ changeDate(session_form.date_time) }}</td>
                                <td>{{ session_form?.PresentStage?.stage }}</td>
                                <td>{{ session_form?.NextStage?.stage }}</td>
                                <td>{{ changeDateTime(session_form?.reminder_date_time) }}</td>
                                <td>{{ session_form?.status ? 'Completed' : 'Pending' }}</td>
                                <td>{{ session_form?.remarks }}</td>
                                <td class="text-center">
                                    <nav>
                                        <a data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="edit(session_form)" href="javascript:void(0)" class="text-success me-2"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        <a @click.prevent="view(session_form)" href="javascript:void(0)" class="text-success me-2"><i class="ri-eye-line fs-18 lh-1"></i></a>
                                    </nav>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
         <div class="mt-3">
                <div class="d-flex justify-content-between align-items-center">
                    <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                    </select>
                    <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta?.totalRows }} entries</span>
                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                </div>
            </div>
    </div>
    <!-- Modal -->
<div class="modal fade" data-bs-backdrop='static' id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Update Stage</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
      </div>
      <div class="modal-body">
        <label class="form-label">Reminder Date</label>
        <br>
        <!-- <input type="datetime-local" class="form-control" placeholder="Date Time" aria-label="Date Time" v-model="stage.reminder_date_time" aria-describedby="button-addon2"> -->
        <flatPickr
            class="form-control"
            placeholder="Select Reminder Date and Time"
            aria-label="Date Time"
            aria-describedby="button-addon2"
            :class="{ 'is-invalid': errors?.reminder_date_time }"
            v-model="stage.reminder_date_time"
            :config="{
                enableTime: true,
                dateFormat: 'd-m-Y H:i',
                allowInput: true,
                static: true
            }"
            style="width: 468px;">
        </flatPickr>
        <span v-if="errors.reminder_date_time" class="invalid-feedback">{{ errors.reminder_date_time}}</span>
        <br>
        <br>
        <label class="form-label">Present Stage</label>
        <select class="form-control" v-model="stage.stage_id" :class="{ 'is-invalid': errors.stage_id }">
            <option value="">Select Present Stage</option>
            <option v-for="stage, key in modalStages" :key="key" :value="stage.stage_id">{{ stage.stage }}</option>
        </select>
        <br>
        <label class="form-label">Next Stage</label>
        <select class="form-control" v-model="stage.next_stage_id" :class="{ 'is-invalid': errors.next_stage_id }">
            <option value="">Select Next Stage</option>
            <option v-for="stage, key in modalStages" :key="key" :value="stage.stage_id">{{ stage.stage }}</option>
        </select>
      </div>
      <div class="modal-footer">
        <button type="button" @click="saveStage()" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
    import SchoolSearch from "@/components/SchoolSearch.vue";
    import Pagination from "@/components/Pagination.vue";
    import Search from "@/components/Search.vue";
    // import moment from "moment";
    import moment from 'moment-timezone';
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import axios from 'axios';
    import VueSlider from 'vue-3-slider-component'
    export default {
        components: { Pagination, Search, SchoolSearch, flatPickr, VueSlider },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "desc",
                    keyword: "date_time",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    district_id: "",
                    school_id: "",
                    school_name:"",
                    user_id: "",
                    board: "",
                    stage_id:"",
                    date_time:"",
                    from_date_time: "",
                    to_date_time: "",
                    kg_strength: "",
                    kg_strength_min: "",
                    kg_strength_max: "",
                    pincode: "",
                    place: "",
                    is_latest: false,
                },
                from_date_time: "",
                to_date_time: "",
                value: [0, 1000],
                stage: {
                    stage_id: "",
                    next_stage_id:"",
                    session_comment_id:"",
                    reminder_date_time:"",
                },
                stage_status: false,
                session_forms: [],
                districts: [],
                users: [],
                schools: [],
                stages:[],
                errors: [],
                district_ids: [],
                config: {
                    mode:'range',
                    defaultDate: [],
                    dateFormat: 'd-m-Y',
                }
            };
        },
        mounted() {
            this.index();
        },
        computed: {
            filteredSessionForms() {
                if(this.meta.kg_strength){
                    return this.session_forms.filter((session_form) => {
                        // Ensure SessionFields exists and includes an object with field_name === 'KG Strength'
                        return session_form?.School?.SessionFields?.some(
                            (field) => field?.field_name === 'KG Strength' && field?.value
                        );
                    });
                }
                else{
                    return this.session_forms
                }
            },
            modalStages() {
                const selectedIds = [this.stage.stage_id, this.stage.next_stage_id]
                    .filter((id) => id !== "" && id != null)
                    .map((id) => Number(id));
                return this.stages.filter((stage) => !stage.deleted_at || selectedIds.includes(Number(stage.stage_id)));
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {

                // console.log('vm.$store.getters.report_search?.from_date_time:------', vm.$store.getters.report_search?.from_date_time)
                // console.log('vm.$store.getters.report_search?.to_date_time:------', vm.$store.getters.report_search?.to_date_time)
                vm.meta.district_id = vm.$store.getters.report_search?.district_id ? vm.$store.getters.report_search?.district_id : '';
                vm.meta.school_id = vm.$store.getters.report_search?.school_id ? vm.$store.getters.report_search?.school_id : '';
                vm.meta.user_id = vm.$store.getters.report_search?.user_id ? vm.$store.getters.report_search?.user_id : '';
                vm.meta.stage_id = vm.$store.getters.report_search?.stage_id ? vm.$store.getters.report_search?.stage_id : '';
                vm.from_date_time = vm.$store.getters.report_search?.from_date_time ? vm.changeDateMeta(vm.$store.getters.report_search?.from_date_time) : '';
                vm.to_date_time = vm.$store.getters.report_search?.to_date_time ? vm.changeDateMeta(vm.$store.getters.report_search?.to_date_time) : '';
                vm.meta.kg_strength = vm.$store.getters.report_search?.kg_strength ? vm.$store.getters.report_search?.kg_strength : '';
                vm.meta.kg_strength_min = vm.$store.getters.report_search?.kg_strength_min ? vm.$store.getters.report_search?.kg_strength_min : 0;
                vm.meta.kg_strength_max = vm.$store.getters.report_search?.kg_strength_max ? vm.$store.getters.report_search?.kg_strength_max : 1000;
                vm.meta.board = vm.$store.getters.report_search?.board ? vm.$store.getters.report_search?.board : '';
                vm.meta.pincode = vm.$store.getters.report_search?.pincode ? vm.$store.getters.report_search?.pincode : '';
                vm.meta.place = vm.$store.getters.report_search?.place ? vm.$store.getters.report_search?.place : '';
                vm.meta.is_latest = vm.$store.getters.report_search?.is_latest ? vm.$store.getters.report_search?.is_latest : false;
                vm.district_ids = [];
                if(vm.$store.getters.report_search?.district_id){
                    vm.district_ids.push(vm.$store.getters.report_search?.district_id);
                }
                vm.config.defaultDate = [vm.from_date_time, vm.to_date_time]
                vm.value = [];
                vm.value = [vm.meta.kg_strength_min, vm.meta.kg_strength_max];
                if(from.name == 'SessionForm.View'){
                    vm.meta.page = vm.$store.getters.current_page
                }else{
                    vm.meta.page = 1
                }

            });
        },
        methods: {
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            changeDate(date_time){
                return moment(date_time).format("DD-MM-YYYY hh:mm:ss A");
            },
            changeDateTime(date_time) {
                // console.log('date_time:----', date_time)
                return moment.utc(date_time).format("DD-MM-YYYY hh:mm:ss A");
                // return moment.tz(date_time, "Asia/Kolkata").utc().format("DD-MM-YYYY hh:mm:ss")
            },
            changeDateTimeMeta(date_time) {
                return moment(date_time, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
            },
            changeDateMeta(date_time){
                return moment(date_time).format("DD-MM-YYYY hh:mm:ss");
            },
            getSelectedDates(dates){
				let vm = this;
				vm.from_date_time = moment(dates[0]).format("DD-MM-YYYY")
				vm.to_date_time = moment(dates[1]).format("DD-MM-YYYY")
			},
            index() {
                let vm = this;
                vm.meta.kg_strength_min = vm.value[0];
                vm.meta.kg_strength_max = vm.value[1];
                if(vm.from_date_time && vm.to_date_time){
                    vm.meta.from_date_time = vm.changeDateTimeMeta(vm.from_date_time)
                    vm.meta.to_date_time = vm.changeDateTimeMeta(vm.to_date_time)
                }
                vm.$store.commit("setReportSearch", vm.meta)

                vm.$store.dispatch("post", { uri: "session/paginateSessionForms", data: vm.meta })
                .then(function (response) {
                    vm.session_forms = response.data.data.data;
                    vm.meta.totalRows = response.data.data.meta.total;
                    vm.meta.lastPage = response.data.data.meta.lastPage;
                    vm.meta.from = response.data.data.meta.from;
                    const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                    vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    if (!vm.stage_status) {
                        vm.getDistricts();
                    }
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            getDistricts() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "district/getAllDistricts" })
                .then((response) => {
                    // console.log("distt", response.data.data);
                    loader.hide();
                    vm.districts = response.data.data;
                    vm.getUsers();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            updateDistrictID(value) {
                this.district_ids = [];
                this.district_ids.push(value);
            },
            getSchools(value) {
                let vm = this;
                let loader = vm.$loading.show();
                let district_ids = [];
                district_ids.push(value);
                vm.$store.dispatch("post", { uri: "school/districtSchool", data: { district_ids: district_ids } })
                .then((response) => {
                    loader.hide();
                    // console.log("r00--", response.data.data);
                    vm.schools = response.data.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            getUsers() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "users/getUsers" })
                .then((response) => {
                    loader.hide();
                    vm.users = response.data.data;
                    vm.getStages();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getStages(){
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "stages/getStage" })
                .then((response) => {
                    loader.hide();
                    vm.stages = response.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            saveStage() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "session/UpdateSeesionSatge",data: vm.stage })
                .then((response) => {
                    loader.hide();
                    // console.log("rr--", response)
                    vm.stage_status = true;
                    vm.$store.dispatch("success", response.data.message);
                    document.getElementById("closeModal").click();
                    vm.index();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            view(session_form) {
                this.$store.commit("setCurrentPage", parseInt(this.meta.page))
                this.$router.push("/session_forms/" + session_form.School.school_id + "/view");
            },
            edit(session_form) {
                // console.log("session_form", session_form)

                this.stage.stage_id = session_form.stage_id ? session_form.stage_id : '';
                this.stage.next_stage_id = session_form.next_stage_id ? session_form.next_stage_id : "";
                this.stage.reminder_date_time = session_form.reminder_date_time ? moment.utc(session_form.reminder_date_time).format("DD-MM-YYYY hh:mm:ss") : "";
                this.stage.session_comment_id = session_form.session_comment_id;
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            reset(){
                let vm = this;
                vm.district_ids = [];
                vm.meta.district_id = ""
                vm.meta.school_id =  ""
                vm.meta.school_name = ""
                vm.meta.user_id =  ""
                vm.meta.board = ""
                vm.meta.stage_id = ""
                vm.meta.date_time = ""
                vm.meta.from_date_time = ""
                vm.meta.to_date_time = ""
                vm.from_date_time = ""
                vm.to_date_time = ""
                vm.meta.kg_strength = ""
                vm.meta.kg_strength_min = 0
                vm.meta.kg_strength_max = 1000
                vm.value = [vm.meta.kg_strength_min, vm.meta.kg_strength_max];
                vm.meta.pincode = '';
                vm.meta.place = '';
                if (vm.$refs.flatpickr) {
                    vm.$refs.flatpickr.fp.setDate([]);
                }
                vm.search();
            },
            selectSchool(e) {
                const school = e.target.value;
                this.meta.school_name = school.school_name;
                this.meta.school_id = school.school_id;
                // this.activity.asset_code = asset.asset_code;

            },
            checkInitalDistrict(e) {
                this.errors = [];
                if (e.target.value == 0) {
                    this.errors.district_error = "Please select district first"
                }
            },
            async downloadExcel() {
                try {
                    const response = await axios({
                        url: this.$store.getters.apiUrl + 'api/' + 'session/excelDownloadSessionForms', // Your Node.js server endpoint
                        method: 'POST',
                        responseType: 'blob', // Important to handle the file as a blob
                        headers: {
                            Authorization: "Bearer " + this.$store.getters.token, // Add the token from Vuex store
                        },
                        data: this.meta,
                    });

                    // Create a link element to download the file
                    const dateTime = moment().format('DD-MM-YYYY_HH-mm-ss');
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `session_report_${dateTime}.xlsx`); // Set the file name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error('Error downloading the file', error);
                }
            }
        }
    };
</script>


<style scoped>
    /* .sticky-col {
        position: -webkit-sticky;
        position: sticky;
        background-color: #fff;
        z-index: 3;
        border-right: 1px solid #dee2e6;
    }

    .col-0 {
        left: 0;
        width: 50px;
    }

    .col-1 {
        left: 40px;
        width: 175px;
    }

    .col-2 {
        left: 165px;
        background-color: #fff;
        min-width: 550px;
    }

    .col-3 {
        left: calc(50px + 600px);
        width: 100px;
    }

    .table {
        table-layout: auto;
        width: 100%;
    }

    .table-responsive {
        overflow-x: auto;
    } */

     /* Ensure the first 4 columns are sticky */
    .sticky {
        position: sticky;
        left: 0;
        background-color: #fff; /* Optional: Adds a white background for better visibility */
        z-index: 1; /* Ensures the sticky columns stay above other columns */
    }

    /* Optional: Apply a background color for the header cells */
    .sticky-col {
        background-color: #f8f9fa; /* Light grey background */
    }

    /* Fix the sticky columns on scroll */
    .sticky-col.col-0 {
        left: 0;
        z-index: 2; /* Higher index for the first column */
    }

    .sticky-col.col-1 {
        left: 45px;
        z-index: 2;
    }

    .sticky-col.col-2 {
        left: 119px;
        z-index: 2;
        /* max-width: 521px;   */
    }

    .sticky-col.col-3 {
        left: 368px;
        z-index: 2;
    }

    table th, table td {
        padding: 6px 10px;
        /* border: 1px solid #dee2e6; */
    }
    .text-wrap {
        /* word-wrap: break-word; */
        /* word-break: break-word; */
        /* white-space: normal; */
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        /* overflow: hidden; */
        /* text-overflow: ellipsis; */
        width: 250px; /* Adjust width to fit your layout */
    }
</style>